import React from "react"
import CCOCard from "../../fundamentals/CCOCard";
import {metaDataElementWithId} from "../../preview/previewMetaData";
import {usePreviewContext} from "../../../context/PreviewContext";
import {SosDonationProductType} from "../../types";
import ProductTeaserCardContent from "./ProductTeaserCardContent";

interface Props {
    item: SosDonationProductType,
    descriptionCharLimit?: number
    horizontal?: boolean
    teasercardLocation?: string
}

/**
 * Teasercard für Gridlayout
 */
function ProductTeaserCard(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    if (props.item != null) {
        return <CCOCard dataCypress='productTeaserCard'
                        teasercardLocation={props.teasercardLocation}
                        item={props.item}
                        padding={0}
                        hasFocusedStyle {...metaDataElementWithId(isPreview, props.item.id)}>
            <ProductTeaserCardContent item={props.item}
                                      horizontal={props.horizontal}
                                      descriptionCharLimit={props.descriptionCharLimit}/>
        </CCOCard>
    } else {
        return null
    }
}

export default ProductTeaserCard
